var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.25C3.04375 0.25 0.25 3.04375 0.25 6.5C0.25 9.95625 3.04375 12.75 6.5 12.75C9.95625 12.75 12.75 9.95625 12.75 6.5C12.75 3.04375 9.95625 0.25 6.5 0.25ZM9.625 8.74375L8.74375 9.625L6.5 7.38125L4.25625 9.625L3.375 8.74375L5.61875 6.5L3.375 4.25625L4.25625 3.375L6.5 5.61875L8.74375 3.375L9.625 4.25625L7.38125 6.5L9.625 8.74375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.25C3.04375 0.25 0.25 3.04375 0.25 6.5C0.25 9.95625 3.04375 12.75 6.5 12.75C9.95625 12.75 12.75 9.95625 12.75 6.5C12.75 3.04375 9.95625 0.25 6.5 0.25ZM9.625 8.74375L8.74375 9.625L6.5 7.38125L4.25625 9.625L3.375 8.74375L5.61875 6.5L3.375 4.25625L4.25625 3.375L6.5 5.61875L8.74375 3.375L9.625 4.25625L7.38125 6.5L9.625 8.74375Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.968b4fa0.svg";
export { ForwardRef as ReactComponent };